module.exports = "./img/3a9786e8acf47568a4fbf69130bc2d13.jpg";